
import { computed, defineComponent, ref } from "vue";
import store from "@/stores";
import {
  IErrorResponse,
  isErrors,
  ErrorMessageFilter,
  consts,
} from "@/services/Models";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { AxiosResponse } from "axios";

export default defineComponent({
  name: "ChangePassword",
  components: { ErrorMessage },
  props: {
    isShowModal: { type: Boolean },
  },
  setup(props, context) {
    const login = store.useLoginStore();
    const errors = ref<IErrorResponse[]>([]);
    const oldPassword = ref("");
    const newPassword = ref("");
    const newPasswordForCheck = ref("");

    const errorMessages = computed(() => ({
      OldPassword: ErrorMessageFilter(errors.value, "OldPassword"),
      NewPassword: ErrorMessageFilter(errors.value, "NewPassword"),
      CheckPassword: ErrorMessageFilter(errors.value, "CheckPassword"),
    }));

    const isShowModalInner = computed({
      get: () => props.isShowModal,
      set: (newValue) => {
        context.emit("update:isShowModal", newValue);
        errors.value = [];
        oldPassword.value = "";
        newPassword.value = "";
        newPasswordForCheck.value = "";
      },
    });

    const change = async () => {
      // パスワード変更
      await login
        .setPassword(
          oldPassword.value,
          newPassword.value,
          newPasswordForCheck.value
        )
        .then(() => {
          errors.value = [];
          isShowModalInner.value = false;
          oldPassword.value = "";
          newPassword.value = "";
          newPasswordForCheck.value = "";
        })
        .catch((ex: AxiosResponse) => {
          if (isErrors(ex.data)) {
            errors.value = ex.data as IErrorResponse[];
          } else {
            alert(consts.changePasswordFailure);
          }
        });
    };

    return {
      isShowModalInner,
      errorMessages,
      oldPassword,
      newPassword,
      newPasswordForCheck,
      change,
      consts,
    };
  },
});
